







import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { bannerList } from "./data";
@Component
export default class Header extends Vue {
  @Prop() img!: string;
  bannerList = bannerList;

  get imgUrl(): string | undefined {
    const { path } = this.$route;
    if (this.img) return this.img;
    return this.bannerList.find(ele => path.indexOf(ele.path) > -1)?.banner;
  }
}
